export default {
  client_type: [{
    value: "school",
    label: "School"
  }, {
    value: "publicAdmin",
    label: "Public Administration"
  }, {
    value: "company",
    label: "Company"
  }, {
    value: "individual",
    label: "Individual"
  }, {
    value: "club",
    label: "Sport Club"
  }],
  client_tabs: [{
    label: "Client",
    value: "client"
  }, {
    label: "People of contact",
    value: "person_of_contact"
  }, {
    label: "Billing",
    value: "billing"
  }, {
    label: "Datos FACE",
    value: "face"
  }],
  client_tabs_edit: [{
    label: "Client",
    value: "client"
  }, {
    label: "Billing",
    value: "billing"
  }, {
    label: "Datos FACE",
    value: "face"
  }],
  opportunity_source: [{
    value: "own",
    label: "Own"
  }, {
    value: "product",
    label: "Sportmadness product"
  }],
  service_type: [{
    value: "event",
    label: "Event"
  }, {
    value: "campus",
    label: "Campus"
  }, {
    value: "academy",
    label: "Academy"
  }],
  opportunity_status: [{
    value: 0,
    label: "Lead"
  }, {
    value: 1,
    label: "Proposal"
  }, {
    value: 2,
    label: "Offer"
  }, {
    value: 3,
    label: "On hold"
  }, {
    value: 4,
    label: "Won"
  }, {
    value: 5,
    label: "Lost"
  }],
  task_type: [{
    value: "once",
    label: "Once"
  }, {
    value: "recurring",
    label: "Recurring"
  }],
  frequency: [{
    value: "day",
    label: "Daily"
  }, {
    value: "week",
    label: "Weekly"
  }, {
    value: "month",
    label: "Monthly"
  }],
  weekday: [{
    value: 1,
    label: "Monday"
  }, {
    value: 2,
    label: "Tuesday"
  }, {
    value: 3,
    label: "Wednesday"
  }, {
    value: 4,
    label: "Thursday"
  }, {
    value: 5,
    label: "Friday"
  }, {
    value: 6,
    label: "Saturday"
  }, {
    value: 7,
    label: "Sunday"
  }],
  project_status: [{
    value: "plan",
    label: "Plan"
  }, {
    value: "docheck",
    label: "Do & Check"
  }, {
    value: "close",
    label: "Close"
  }],
  project_type: [{
    value: "b2b",
    label: "B2B"
  }, {
    value: "b2c",
    label: "B2C"
  }],
  add_project_steps: ["Project type", "Project information", "Template"],
  add_task_steps: ["Enter group title", "New task information"],
  payment_methods_types: [{
    value: "bank",
    label: "Bank account"
  }, {
    value: "cash",
    label: "Cash"
  }, {
    value: "stripe",
    label: "Stripe"
  }],
  series_types: [{
    value: "regular",
    label: "Normal"
  }, {
    value: "amending",
    label: "Amending"
  }],
  taxes: [{
    percentage: 0.21,
    label: "IVA 21%",
    value: "iva_21"
  }, {
    percentage: 0.16,
    label: "IVA 16%",
    value: "iva_16"
  }, {
    percentage: 0.1,
    label: "IVA 10%",
    value: "iva_10"
  }, {
    percentage: 0,
    label: "No IVA",
    value: "no_iva"
  }],
  invoice_status: [{
    value: "pending",
    label: "Pending"
  }, {
    value: "paid",
    label: "Paid"
  }, {
    value: "overdue",
    label: "Overdue"
  }, {
    value: "amended",
    label: "Amended"
  }, {
    value: "amending",
    label: "Amending"
  }, {
    value: "draft",
    label: "Draft"
  }, {
    value: "payment_failed",
    label: "Payment failed"
  }, {
    value: "open",
    label: "Payment failed"
  }, {
    value: "uncollectable",
    label: "Uncollectable"
  }],
  invoice_status_labels: {
    pending: "Pending",
    overdue: "Overdue",
    amended: "Amended",
    amending: "Amending",
    draft: "Draft",
    payment_failed: "Payment failed",
    paid: "Paid",
    uncollectable: "Uncollectable"
  },
  invoice_categories: [{
    value: "initial_fee",
    label: "Initial Fee"
  }, {
    value: "recurring_fee",
    label: "Recurring Fee"
  }, {
    value: "office",
    label: "Office"
  }, {
    value: "marketing",
    label: "Marketing"
  }, {
    value: "others",
    label: "Others"
  }, {
    value: "marketplace",
    label: "Marketplace"
  }],
  bestpractices_types: {
    event: "Event",
    campus: "Campus",
    academy: "Academy"
  },
  attendance_status: {
    yes: "Yes",
    no: "No",
    maybe: "Maybe",
    injured: "Injured"
  },
  checkInStatus: {
    attended: "Attended",
    not_attended: "Didn't attend"
  }
}; // import selects from '../../../../assets/selects'